import { createTheme } from '@mui/material/styles';

// Create a theme instance.
const theme = createTheme({
  typography: {
    fontFamily: ['Inter', 'sans-serif', 'Roboto', '"Helvetica Neue"', 'Arial'].join(','),
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiCheckbox: {
      defaultProps: {
        color: 'primary',
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
  },
  palette: {
    primary: {
      main: '#354463',
    },
  },
});

export default theme;
